export const FAQ_LIST_REQUEST = "FAQ_LIST_REQUEST";
export const FAQ_LIST_RECEIVE = "FAQ_LIST_RECEIVE";
export const FAQ_LIST_FAILURE = "FAQ_LIST_FAILURE";
export const RESET_FAQ_LIST = "RESET_FAQ_LIST";